// extracted by mini-css-extract-plugin
module.exports = {"container":"filter-chips_container__21hXM","chip":"filter-chips_chip__bKWlS"};